<template>
  <el-row>
    <el-col>
      <el-card
        v-loading="!isReady || !isLoaded"
        shadow="never"
        style="min-height: calc(100vh - 200px)"
      >
        <iframe
          v-if="isReady"
          v-show="isLoaded"
          ref="iframe"
          :src="url"
          class="border-0 w-100"
          style="min-height: calc(100vh - 200px)"
          @load="isLoaded = true"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { iframeResizer } from 'iframe-resizer'

/**
 * The v2 [manager] application iframe component.
 */
export default {
  props: {
    view: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isReady: false,
      isLoaded: false,
      token: undefined,
      tenancy: undefined
    }
  },
  computed: {
    url () {
      let url

      if (this.isReady) {
        url = new URL(`manage/?view=${this.view}&do=${this.action}&iframe=true&tenancy=${this.tenancy}&token=${this.token}`, process.env.VUE_APP_LEGACY_MANAGER_URI)
      }

      return url
    }
  },
  watch: {
    isReady (value) {
      if (value) {
        this.$nextTick(() => {
          iframeResizer(this.$refs['iframe'])
        })
      }
    }
  },
  async mounted () {
    this.isReady = false

    this.tenancy = (await this.$session.instance).tenancy.id
    this.token = await this.$session.token

    this.isReady = true
  },
  beforeDestroy () {
    this
      .$refs['iframe']
      .iFrameResizer
      .close()
  }
}
</script>
